import React, { useEffect, useState } from "react";

// Bootstrap components
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Custom Styles
import "../scss/pages/aboutUs.styles.scss";

// Axios
import axios from "axios";

// Assets
import AboutUsInitial from "../assets/img/about-us-initial.jpg";
import AboutUsQuality from "../assets/img/about-us-policy.jpg";

function AboutUs() {
  const [aboutUsData, setAboutUsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({ error: false, message: "" });
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/graphql`,
          {
            query: `
            {
              acercaDe {
                data {
                  attributes{
                    Imagen{
                      imagen{
                        data{
                          attributes{
                            url
                          }
                        }
                      }
                    }
                    Biografia{
                      Titulo
                      Subtitulo
                      mensaje
                      imagen{
                        data{
                            attributes{
                              url
                            }
                          }
                        }
                    }
                    EstadisticasNosotros{
                      Numero
                      Titulo
                      id
                    }
                    Valores{
                      Titulo
                      Descripcion
                      Valores{
                        TituloValor
                        Descripcion
                      }
                    }
                    ImageBreaker{
                        image{
                          data{
                          attributes{
                            url
                          }
                        }
                        }
                    }
                    MisionVision{
                      Titulo
                      Parrafo
                      Tarjeta{
                        Titulo
                        Descripcion
                      }
                    }
                    PoliticaCalidad{
                      Titulo
                      Informacion
                      ParrafoSecundario
                      imagen{
                        data{
                          attributes{
                            url
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
          }
        );
        setAboutUsData(response.data.data.acercaDe.data.attributes);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError({ error: true, message: error.message || error.toString() });
      } finally {
        setLoading(false);
      }
      // console.log(response.data.data);
    };

    fetchData();
  }, []);
  if (loading) {
    return (
      <section className="loading">
        <Container>
          <h6>Cargando información...</h6>
        </Container>
      </section>
    );
  }
  if (error.error) {
    return (
      <section className="loading">
        <Container>
          <h6>No se pudo cargar la información en este momento ⌛️</h6>
        </Container>
      </section>
    );
  }
  const {
    Imagen,
    Biografia,
    EstadisticasNosotros,
    Valores,
    ImageBreaker,
    MisionVision,
    PoliticaCalidad,
    ParrafoSecundario,
  } = aboutUsData || {};

  const sections =
    PoliticaCalidad.Informacion.split(/\n(?=\d+\.\s)/).filter(Boolean);

  const listItems = sections.map((section) => {
    // Extract heading number and text from the beginning of the section
    const match = section.match(/^(\d+)\.\s(.*?):\s/);

    if (match) {
      const number = match[1];
      const heading = match[2].trim();
      const paragraph = section.replace(match[0], "").trim();

      return {
        number,
        heading,
        paragraph,
      };
    }

    return {
      number: null,
      heading: section.trim(),
      paragraph: null,
    };
  });

  // Rendering paragraphs before the list
  const paragraphsBeforeList =
    PoliticaCalidad.Informacion.split(/\n\n\d+\.\s/)[0].split("\n\n");
  // console.log(listItems);
  return (
    <>
      <section
        className="jumbotron--about-us"
        style={{
          backgroundImage: `url(${Imagen.imagen.data.attributes.url})`,
          // backgroundImage: `url(${process.env.REACT_APP_API_URL}${Imagen.imagen.data.attributes.url})`,
        }}
      >
        <Container fluid></Container>
      </section>
      <section className="about-us__description">
        <Container fluid>
          <Row>
            <Col xs="12" lg="7">
              <h5>Nosotros</h5>
              <div className="about-us__description__heading">
                <h4>{Biografia.Titulo}</h4>{" "}
                <div className="about-us__description__heading__spacer"></div>{" "}
                <h5>{Biografia.Subtitulo}</h5>
              </div>
              {Biografia.mensaje.split("\n\n").map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
              {/* <p>
                Cum sociis natoque penatibus et magnis dis parturient montes,
                nascetur ridiculus mus. Nulla consequat massa quis enim. Donec
                pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In
                enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo.
                Nullam dictum felis eu pede mollis pretium. Integer tincidunt.
              </p>
              <p>
                Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate
                eleifend tellus. Aenean leo ligula, porttitor eu, consequat
                vitae, eleifend ac, enim.
              </p> */}
              <h3>Dr. Emmanuel Ludwig Lara Chávez</h3>
              <h6>Director y Maestro de ENSFA.</h6>
            </Col>
            <Col
              xs="12"
              lg="5"
              className="text-end about-us__description__media"
            >
              <img
                src={`${Biografia.imagen.data.attributes.url}`}
                // src={`${process.env.REACT_APP_API_URL}${Biografia.imagen.data.attributes.url}`}
                alt=""
                className="img-fluid"
              />
            </Col>
          </Row>
        </Container>
      </section>
      <section className="about-us__stats">
        <Container>
          <Row>
            {EstadisticasNosotros.map((stat, key) => (
              <Col xs="5" lg="3" className="text-center" key={key}>
                <h3>{stat.Numero}</h3>
                <h5>{stat.Titulo}</h5>
              </Col>
            ))}
            {/*             
            <Col xs="7" lg="3" className="text-center">
              <h3>32</h3>
              <h5>Cursos y licentiaturas</h5>
            </Col>
            <Col xs="5" lg="3" className="text-center mt-3 mt-lg-0">
              <h3>50</h3>
              <h5>Docentes capacitados</h5>
            </Col>
            <Col xs="7" lg="3" className="text-center mt-3 mt-lg-0">
              <h3>12</h3>
              <h5>Edificios tecnológicos</h5>
            </Col> */}
          </Row>
        </Container>
      </section>
      <section className="about-us__values">
        <Container fluid>
          <h3>{Valores.Titulo}</h3>
          <p>{Valores.descripcion}</p>
          <div className="about-us__values__list">
            {Valores.Valores.map((value, key) => (
              <div className="about-us__values__list__item" key={key}>
                <h6>{value.TituloValor}</h6>
                <p>{value.Descripcion}</p>
              </div>
            ))}

            {/* <div className="about-us__values__list__item">
              <h6>Calidad:</h6>
              <p>
                Compromiso con la excelencia académica, la mejora continua y la
                entrega de servicios educativos de alta calidad.
              </p>
            </div>
            <div className="about-us__values__list__item">
              <h6>Calidad:</h6>
              <p>
                Compromiso con la excelencia académica, la mejora continua y la
                entrega de servicios educativos de alta calidad.
              </p>
            </div>
            <div className="about-us__values__list__item">
              <h6>Calidad:</h6>
              <p>
                Compromiso con la excelencia académica, la mejora continua y la
                entrega de servicios educativos de alta calidad.
              </p>
            </div>
            <div className="about-us__values__list__item">
              <h6>Calidad:</h6>
              <p>
                Compromiso con la excelencia académica, la mejora continua y la
                entrega de servicios educativos de alta calidad.
              </p>
            </div>
            <div className="about-us__values__list__item">
              <h6>Calidad:</h6>
              <p>
                Compromiso con la excelencia académica, la mejora continua y la
                entrega de servicios educativos de alta calidad.
              </p>
            </div>
            <div className="about-us__values__list__item">
              <h6>Calidad:</h6>
              <p>
                Compromiso con la excelencia académica, la mejora continua y la
                entrega de servicios educativos de alta calidad.
              </p>
            </div>
            <div className="about-us__values__list__item">
              <h6>Calidad:</h6>
              <p>
                Compromiso con la excelencia académica, la mejora continua y la
                entrega de servicios educativos de alta calidad.
              </p>
            </div>
            <div className="about-us__values__list__item">
              <h6>Calidad:</h6>
              <p>
                Compromiso con la excelencia académica, la mejora continua y la
                entrega de servicios educativos de alta calidad.
              </p>
            </div>
            <div className="about-us__values__list__item">
              <h6>Calidad:</h6>
              <p>
                Compromiso con la excelencia académica, la mejora continua y la
                entrega de servicios educativos de alta calidad.
              </p>
            </div>
            <div className="about-us__values__list__item">
              <h6>Calidad:</h6>
              <p>
                Compromiso con la excelencia académica, la mejora continua y la
                entrega de servicios educativos de alta calidad.
              </p>
            </div>
            <div className="about-us__values__list__item">
              <h6>Calidad:</h6>
              <p>
                Compromiso con la excelencia académica, la mejora continua y la
                entrega de servicios educativos de alta calidad.
              </p>
            </div>
            <div className="about-us__values__list__item">
              <h6>Calidad:</h6>
              <p>
                Compromiso con la excelencia académica, la mejora continua y la
                entrega de servicios educativos de alta calidad.
              </p>
            </div> */}
          </div>
        </Container>
      </section>
      <section
        className="media-breaker"
        style={{
          backgroundImage: `url(${ImageBreaker.image.data.attributes.url})`,
          // backgroundImage: `url(${process.env.REACT_APP_API_URL}${ImageBreaker.image.data.attributes.url})`,
        }}
      ></section>
      <section className="about-us__mission-and-vision" id="mision">
        <Container fluid>
          <h3>{MisionVision.Titulo}</h3>
          <p>{MisionVision.Parrafo}</p>
          <div>
            {MisionVision.Tarjeta.map((card, key) => (
              <div key={key} className="about-us__mission">
                <h3>{card.Titulo}</h3>
                <p>{card.Descripcion}</p>
              </div>
            ))}

            {/* <div className="about-us__vision" id="vision">
              <h3>visión</h3>
              <p>
                Mantener el reconocimiento nacional e internacional por la
                calidad académica y de los servicios institucionales para la
                comunidad de aprendizaje desarrollando la capacidad, los valores
                y actitudes en la formación de docentes por medio de la
                docencia, la investigación y la difusión del conocimiento como
                tareas sustantivas que permitan a la comunidad escolar enfrentar
                con éxito los desafíos que la profesión exige en el contexto de
                la sociedad del conocimiento.
              </p>
            </div> */}
          </div>
        </Container>
      </section>
      <section className="quality">
        <Container fluid>
          <Row>
            <Col xs="12" lg="6" className="quality__content">
              <h3>{PoliticaCalidad.Titulo}</h3>
              {paragraphsBeforeList.map((para, index) => (
                <p key={`para-${index}`}>{para}</p>
              ))}
              <ul>
                {listItems.map((item, index) =>
                  item.number ? (
                    <li key={index}>
                      <h6>{item.heading}</h6>
                      <p>{item.paragraph}</p>
                    </li>
                  ) : null
                )}
              </ul>
              {/* <h3>Política de calidad</h3>
              <p>
                La política de calidad para la ENSFA es una declaración oficial
                que expresa el compromiso y la orientación de la institución
                hacia la calidad en todos sus procesos y servicios. Esta
                política establece los principios y objetivos de calidad que la
                ENSFA se compromete a seguir y cumplir en su operación diaria.
              </p>
              <p>
                La política de calidad de la ENSFA es desarrollada y aprobada
                por la alta dirección de la institución, y se comunica a todos
                los miembros de la comunidad educativa, incluyendo directivos,
                docentes, personal administrativo, estudiantes y otras partes
                interesadas relevantes.
              </p>
              <p>
                La política de calidad de la ENSFA incluye los siguientes
                elementos:
              </p>
              <ul>
                <li>
                  Compromiso con la calidad: Declarar el compromiso de la ENSFA
                  para proporcionar una educación de calidad y cumplir con los
                  requisitos y expectativas de sus partes interesadas.
                </li>
                <li>
                  Orientación hacia el estudiante: Enfatizar la importancia de
                  satisfacer las necesidades y expectativas de los estudiantes,
                  brindando un entorno propicio para su desarrollo académico,
                  personal y profesional.
                </li>
                <li>
                  Mejora continua: Promover una cultura de mejora continua en
                  todos los procesos y servicios de la institución, fomentando
                  la identificación y el abordaje de áreas de oportunidad para
                  la excelencia.
                </li>
                <li>
                  Cumplimiento normativo: Comprometerse a cumplir con las
                  regulaciones y normativas aplicables en el ámbito educativo,
                  asegurando la legalidad y la calidad en todas las operaciones.
                </li>
                <li>
                  Desarrollo del personal: Reconocer la importancia del
                  desarrollo, la capacitación y certificación del personal,
                  garantizando su competencia y compromiso con la calidad
                  educativa.
                </li>
              </ul> */}
            </Col>
            <Col xs="12" lg="6" className="quality__media">
              <img
                src={`${PoliticaCalidad.imagen.data.attributes.url}`}
                // src={`${process.env.REACT_APP_API_URL}${PoliticaCalidad.imagen.data.attributes.url}`}
                alt=""
              />
              <div>
                <p>{PoliticaCalidad.ParrafoSecundario}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default AboutUs;
